/**
 * @author Ankit.Mishra
 * @Date: 2024-05-25 13:05:13
 * @Last Modified by: ankit
 * @Last Modified time: 2024-05-25 13:14:33
 */

import { createSelector } from 'reselect';

const selectYscWalletLockUnlockDomain = (state) => state.get('yscWalletLockUnlock');
export const selectYscWalletLockUnlock = () => createSelector(
  selectYscWalletLockUnlockDomain,
  (YscWalletLockUnlock) => YscWalletLockUnlock,
);

export const isWalletLockUnlockLoading = () => createSelector(
  selectYscWalletLockUnlockDomain,
  (YscWalletLockUnlock) => YscWalletLockUnlock.get('isLoading'));

export const walletLockUnlockSuccess = () => createSelector(
  selectYscWalletLockUnlockDomain,
  (YscWalletLockUnlock) => YscWalletLockUnlock.get('lockUnlockWalletSuccess').toJS(),
);



// WEBPACK FOOTER //
// client/containers/YscWalletLockUnlock/selectors.js